import { faCircleQuestion } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { HTMLAttributes, FC } from 'react'
import { P3 } from '../../shared/compass-ui'

interface SuggestionTextProps extends HTMLAttributes<HTMLParagraphElement> {
  isError?: boolean
}

const SuggestionText: FC<SuggestionTextProps> = ({ children, isError = true, ...rest }) => (
  <P3 className="mt-2 text-ink-600" {...rest}>
    <FontAwesomeIcon
      className={`mr-1 ${isError ? 'text-red-600' : 'text-blue-600'}`}
      icon={faCircleQuestion}
    />
    {children}
  </P3>
)

export default SuggestionText
